import React from "react";
import { node } from "prop-types";
import { BlockQuoteItem } from "../../r1/molecules/BlockQuote";
import { Col, Container, Row } from "../../Grid";
import Section from "../../Section";
import Image from "../../Image";
import Block from "../../Block";

export const SectionLogos = ({ children }) => {
	return (
		<Section className="section-customers-logos">
			<Container>{children}</Container>
		</Section>
	);
};

SectionLogos.propTypes = {
	children: node.isRequired,
};

export const RowLogo = ({ children }) => {
	return (
		<Row px py middle>
			{children}
		</Row>
	);
};

RowLogo.propTypes = {
	children: node.isRequired,
};

export const ColLogo = ({ src, ...props }) => {
	return (
		<Col auto>
			<Block spacing={{ md: { px: 8 } }} className="customer-logo__block">
				<Image src={src} {...props} className="customer-logo__image" />
			</Block>
		</Col>
	);
};

ColLogo.propTypes = {
	...Image.propTypes,
};

export const SectionBlockquotesSlider = ({ children, ...props }) => {
	return (
		<Section className="section-blockquotes-slider" {...props}>
			<Container>
				<Row>
					<Col>{children}</Col>
				</Row>
			</Container>
		</Section>
	);
};

SectionBlockquotesSlider.propTypes = {
	children: node.isRequired,
};

export const BlockQuoteSlide = ({ author, institution, ...props }) => {
	return (
		<BlockQuoteItem active isBorderNone author={author} institution={institution} {...props} />
	);
};

BlockQuoteSlide.propTypes = {
	...BlockQuoteItem.propTypes,
};
